/* eslint-disable jsx-a11y/anchor-is-valid */
import './index.less';
import { Select, InputNumber, Button, Input, Table, message } from 'antd';
import { useState, useEffect } from 'react';
import * as api from '@/services/initial';
import { debounce } from 'lodash-es';

const { Option } = Select;
const { TextArea } = Input;
const dict = ['禁用', '启用', '已绑定'];
const EnterpriseList = () => {
  const [num, setNum] = useState<number | string | null>(1);
  const [options, setOptions] = useState<TenantItem[]>([]);
  const [codes, setCodes] = useState<CodeItem[]>([]);
  const [tenantId2, setTenantId2] = useState<string | undefined>(undefined);
  const [tenantId, setTenantId] = useState<string | undefined>(undefined);
  const [status, setStatus] = useState<string>('all');
  const [extendData, setExtendData] = useState<string>(`{
    "config":{
        "departmentAddTypeMark":"departmentAddType=department.addtype.import表示可以导入部门；departmentAddType=department.addtype.manual表示可以新增部门",
        "userAddTypeMark":"userAddType=user.addtype.import表示可以导入用户；userAddType=user.addtype.manual表示可以新增用户",
        "moduleTypeMark":"type=1为企业权限；type=2为项目权限",
        "modelStatusMark":"status=1有效；status=0禁用",
        "projectManagerStatusMark":"projectManagerStatus=false表示不能新增项目，projectManagerStatus=enable表示可以新增项目",
        "departmentAddType":"department.addtype.import",
        "userAddType":"user.addtype.import",
        "projectManagerStatus":"false",
        "modules":[
            {
                "code":"building_lib",
                "name":"封装单体库",
                "status":1,
                "type":1
            },
            {
                "code":"component_lib",
                "name":"构件库",
                "status":1,
                "type":1
            },
            {
                "code":"templete_lib",
                "name":"样板文件库",
                "status":1,
                "type":1
            },
            {
                "code":"material_lib",
                "name":"材质库",
                "status":0,
                "type":1
            },
            {
                "code":"composition",
                "name":"部品库",
                "status":0,
                "type":1
            },
            {
                "code":"bill",
                "name":"清单库",
                "status":0,
                "type":1
            },
            {
                "code":"sys_manager",
                "name":"企业管理",
                "status":1,
                "type":1
            },
            {
                "code":"document",
                "name":"文档管理",
                "status":0,
                "type":2
            },
            {
                "code":"cloud_model",
                "name":"模型协同",
                "status":1,
                "type":2
            },
            {
                "code":"audit_decision",
                "name":"审核决策",
                "status":0,
                "type":2
            },
            {
              "code":"project_manager.add_project",
              "name":"项目管理",
              "status":1,
              "type":2
          },
          {
              "code":"project_manager.import_project",
              "name":"项目管理",
              "status":1,
              "type":2
          }
        ]
    }
}`);
  const [enterpriseId, setEnterpriseId] = useState<string>('');
  const [activationCode, setActivationCode] = useState<string>('');
  const [pageIndex, setPageIndex] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);
  const [total, setTotal] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [dataSource, setDataSource] = useState<CodeItem[]>([]);
  const getTenantList = async () => {
    const res = await api.getTenantList();
    if (res.success) {
      setOptions(res.data.details);
    }
  };
  const getCode = debounce(async () => {
    setLoading(true);
    const res = await api.getCode({
      activationCode,
      enterpriseId,
      pageIndex,
      pageSize,
      status: status === 'all' ? '' : status,
      tenantId: !tenantId ? '' : tenantId,
    });
    if (res.success) {
      setDataSource(res.data.details.records);
      setTotal(res.data.details.total);
    }
    setLoading(false);
  }, 300);
  useEffect(() => {
    getTenantList();
  }, []);
  useEffect(() => {
    getCode();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activationCode, enterpriseId, pageIndex, pageSize, status, tenantId]);
  const handleChange2 = (value: string) => {
    setTenantId2(value);
  };
  const handleChange = (value: string) => {
    setPageIndex(1);
    setTenantId(value);
  };
  const handleStatusChange = (value: string) => {
    setPageIndex(1);
    setStatus(value);
  };
  const onChange = (value: number | string | null) => {
    setNum(value);
  };
  const handleBlur = (e: any) => {
    setNum(Math.round(Number(num)));
  };
  const handleCreate = async () => {
    if (!tenantId2) {
      message.warning('请先选择租户');
      return;
    }
    const res = await api.createCode(num, tenantId2, extendData);
    if (res.success) {
      setCodes(res.data.details);
    }
  };
  const handleEnterpriseIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPageIndex(1);
    setEnterpriseId(e.target.value);
  };
  const handleActivationCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPageIndex(1);
    setActivationCode(e.target.value);
  };

  const handleCode = async (activationCode: string, type: 'enable' | 'disable') => {
    const res = await api.doCode(activationCode, type);
    if (res.success) {
      getCode();
    }
  };

  const columns = [
    {
      title: '激活码',
      dataIndex: 'activationCode',
      key: 'activationCode',
      // align: 'center' as 'center',
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      // align: 'center' as 'center',
      render: (text: number, _: CodeItem) => <div>{dict[text]}</div>,
    },
    {
      title: '创建时间',
      dataIndex: 'createdAt',
      key: 'createdAt',
      // align: 'center' as 'center',
    },
    {
      title: '关联企业ID',
      dataIndex: 'enterpriseId',
      key: 'enterpriseId',
      // align: 'center' as 'center',
      render: (text: any, _: CodeItem) => <div>{text ? text : '--'}</div>,
    },
    {
      title: '关联企业名称',
      dataIndex: 'enterpriseName',
      key: 'enterpriseName',
      // align: 'center' as 'center',
      render: (text: any, _: CodeItem) => <div>{text ? text : '--'}</div>,
    },
    {
      title: '操作',
      dataIndex: 'status',
      key: 'status',
      // align: 'center' as 'center',
      render: (text: any, _: CodeItem) => (
        <div className="action">
          {text === 0 && <a onClick={() => handleCode(_.activationCode, 'enable')}>启用</a>}
          {text === 1 && <a onClick={() => handleCode(_.activationCode, 'disable')}>禁用</a>}
        </div>
      ),
    },
  ];
  const handlePageChange = (page: number, pageSize: number | undefined) => {
    setPageIndex(page);
    setPageSize(pageSize as number);
  };
  const handleExtendDataChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setExtendData(e.target.value);
  };
  return (
    <div className="enterprise-list">
      <div className="top">
        <div className="box">
          <div className="box_top">
            <div>
              <span className="title">租户列表:</span>
              <Select
                allowClear
                placeholder="租户"
                value={tenantId2}
                style={{ width: 200, marginRight: 8 }}
                onChange={handleChange2}
                showSearch
                optionFilterProp="children"
                filterOption={(input: any, option: any) => {
                  if (!!option) {
                    return (
                      (option!.children as unknown as string)
                        ?.toLowerCase()
                        ?.indexOf(input.toLowerCase()) >= 0
                    );
                  } else {
                    return false;
                  }
                }}
              >
                {options.map((option: TenantItem) => (
                  <Option value={option.id} key={option.id}>
                    {option.publisher}
                  </Option>
                ))}
              </Select>
            </div>
            <div>
              <span className="title">创建数量:</span>
              <InputNumber
                min={1}
                value={num}
                step={1}
                onChange={onChange}
                onBlur={handleBlur}
                style={{ width: 100, marginRight: 8 }}
              />
            </div>

            <Button type="primary" onClick={handleCreate}>
              创建激活码
            </Button>
          </div>
          <div style={{ marginTop: 16, width: '100%' }}>
            <div className="title">扩展数据:</div>
            <TextArea
              style={{ marginTop: 4 }}
              placeholder="请输入扩展数据"
              autoSize={{ minRows: 5 }}
              value={extendData}
              onChange={handleExtendDataChange}
            />
          </div>
        </div>
        <div className="list">
          {codes.length > 0 &&
            codes.map((code: CodeItem) => {
              return <div key={code.id}>{code.activationCode}</div>;
            })}
        </div>
      </div>
      <div className="bottom">
        <div className="box">
          <span className="title">租户:</span>
          <Select
            allowClear
            value={tenantId}
            placeholder="租户"
            style={{ width: 200, marginRight: 8 }}
            onChange={handleChange}
            showSearch
            filterOption={(input, option) => {
              if (!!option) {
                return (
                  (option!.children as unknown as string)
                    ?.toLowerCase()
                    ?.indexOf(input.toLowerCase()) >= 0 || false
                );
              } else {
                return false;
              }
            }}
          >
            {options.map((option: TenantItem) => (
              <Option value={option.id} key={option.id}>
                {option.publisher}
              </Option>
            ))}
          </Select>
          <span className="title">激活码状态:</span>
          <Select
            value={status}
            style={{ width: 200, marginRight: 8 }}
            onChange={handleStatusChange}
          >
            <Option value={'all'} key={'all'}>
              全部
            </Option>
            {dict.map((item: string, index: number) => {
              return (
                <Option value={index + ''} key={item}>
                  {item}
                </Option>
              );
            })}
          </Select>
          <span className="title">企业ID:</span>
          <Input
            allowClear
            style={{ width: 200, marginRight: 8 }}
            value={enterpriseId}
            onChange={handleEnterpriseIdChange}
            placeholder="请输入企业id"
          />
          <span className="title">激活码:</span>
          <Input
            allowClear
            style={{ width: 200, marginRight: 8 }}
            value={activationCode}
            onChange={handleActivationCodeChange}
            placeholder="请输入激活码"
          />
        </div>
        <div className="table-box">
          <Table
            rowKey={(record) => record.id}
            dataSource={dataSource}
            columns={columns}
            loading={loading}
            pagination={{
              current: pageIndex,
              onChange: handlePageChange,
              total,
              showSizeChanger: false,
            }}
          />
        </div>
      </div>
    </div>
  );
};
export default EnterpriseList;
